var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background z-1",class:_vm.className},[_c('HeaderContainer',{attrs:{"image":_vm.image,"overlay":_vm.overlay,"opacity":_vm.opacity,"blur":_vm.blur,"css":_vm.css}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }